import React from "react";
import { Form } from "semantic-ui-react";
import styled from "styled-components";

const StyledDropdown = styled(Form.Dropdown)`
  text-align: center;
`;

interface EditableColumnProps {
  content: string | number;
  isTableEditable: boolean;
  options: string[];
  onChange: (content: string) => void;
}

const EditableColumn: React.FC<EditableColumnProps> = ({
  content,
  isTableEditable,
  options,
  onChange,
}) => {
  if(isTableEditable)
  {
    return (
      <StyledDropdown
        text={String(content)}
        onChange={(_: any, data: any) => {
          onChange(data.value);
        }}
        selection
        options={options.map((opt: string, idx: number) => ({
          key: idx,
          value: opt,
          text: opt,
        }))}
      />
    );
  }
  else
  {
    return <React.Fragment>{content}</React.Fragment>;
  }
};

export default EditableColumn;
